import React, { useEffect, useCallback, useMemo } from 'react';
import './Ad5.css';
import { getPublisherId, getAdSlot } from './adConfig';
import { trackAdImpression } from '../utils/gtag';
import simpleAdLoader from '../utils/simpleAdLoader';

const Ad5 = React.memo(() => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  // Memoize ad loading function to prevent recreation on re-renders
  const loadAd = useCallback(async () => {
    try {
      const adElement = document.querySelector('.adsbygoogle-5');
      if (adElement) {
        const success = await simpleAdLoader.loadAd(adElement);
        if (success) {
          trackAdImpression();
        }
      }
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  useEffect(() => {
    if (!isDevelopment) {
      // Defer ad push to idle to reduce main-thread work during initial load (mobile Web Vitals)
      const ric = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
      ric(() => {
        loadAd();
      });
    }
  }, [isDevelopment, loadAd]);

  // Memoize ad style to prevent recreation
  const adStyle = useMemo(() => ({
    display: 'block', 
    width: '100%', 
    height: '90px',
    margin: '10px 0',
    minHeight: '90px'
  }), []);

  // Memoize ad attributes to prevent recreation
  const adAttributes = useMemo(() => ({
    'data-ad-client': getPublisherId(),
    'data-ad-slot': getAdSlot(5),
    'data-ad-format': 'horizontal'
  }), []);

  if (isDevelopment) {
    return (
      <div className="ad-container-5">
        <div className="ad5-placeholder">
          <p>Ad 5 — Banner Ad (728x90)</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ad-container-5">
      <ins
        className="adsbygoogle adsbygoogle-5"
        style={adStyle}
        {...adAttributes}
      ></ins>
    </div>
  );
});

Ad5.displayName = 'Ad5';

export default Ad5;